import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import {styled, Theme, CSSObject} from "@mui/material";

const drawerWidth = 260;
// open or closed sidebar
const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  backgroundColor: '#434242',
  position: 'relative',
  zIndex: '99',
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }), overflowX: "hidden",
  [theme.breakpoints.between(0,1024 )]: {
    position:'fixed'
  },
});
const closedMixin = (theme: Theme): CSSObject => ({
  backgroundColor: '#434242',
  position: 'relative',
  zIndex: '99',
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp, duration: theme.transitions.duration.leavingScreen,
  }), overflowX: "hidden",
  width: `calc(${theme.spacing(8)} + 1px)`,
  [theme.breakpoints.between(0,1024 )]: {
    width: `calc(${theme.spacing(0)})`,
  },
});
// drawer header
export const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

interface AppBarProps extends MuiAppBarProps { open?: boolean; }
// sidebar open or closed functionality
export const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    position: 'fixed',
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));
export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && { ...openedMixin(theme), "& .MuiDrawer-paper": openedMixin(theme), }),
  ...(!open && { ...closedMixin(theme), "& .MuiDrawer-paper": closedMixin(theme), }),
}));